/**
 * `<product page>/buy` and `<product page>/buy-gift`, see BuyPage.svelte.
 * @param {string} value
 * @returns {value is 'buy' | 'buy-gift'}
 */
export function match(value) {
    return value === 'buy' || value === 'buy-gift';
}
